import Sortable from "sortablejs";

export type SortableMoveEvent = Sortable.MoveEvent;
export type SortableEndEvent = Sortable.SortableEvent;
export type SortableOptions = Sortable.Options;

export class SortableAdapter {
    #sortable: Sortable | null = null;

    constructor(private readonly container: HTMLElement) {}

    mount(options: SortableOptions): void {
        this.destroy();
        this.#sortable = Sortable.create(this.container, options);
    }

    destroy(): void {
        this.#sortable?.destroy();
        this.#sortable = null;
    }
}
